/*
 *
 * SavingWallet selectors
 *
 */

import { createSelector } from 'reselect';
import { SavingWalletState, initialState } from './reducer';

const selectSavingWalletDomain = (state: any) => state.savingWallet || initialState;

const makeSelectWalletData = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.walletData);

const makeSelectLoading = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.loading);

const makeSelectError = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.error);

const makeSelectPreviousPoints = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.previousPoints);

const makeSelectMilestoneToShow = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.milestoneToShow);

const makeSelectShowingMilestone = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.showingMilestone);

const makeSelectTotalPoints = () =>
  createSelector(
    selectSavingWalletDomain, 
    (substate: SavingWalletState) => substate.walletData?.data?.totalPoints || 0
  );

const makeSelectHasSavingWallet = () =>
  createSelector(
    selectSavingWalletDomain, 
    (substate: SavingWalletState) => substate.walletData?.data?.hasSavingWallet || false
  );

const makeSelectWalletHistory = () =>
  createSelector(
    selectSavingWalletDomain, 
    (substate: SavingWalletState) => substate.walletData?.data?.history || []
  );

const makeSelectTransactionsData = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.transactionsData);

const makeSelectTransactionsLoading = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.transactionsLoading);

const makeSelectTransactionsError = () =>
  createSelector(selectSavingWalletDomain, (substate: SavingWalletState) => substate.transactionsError);

const makeSelectWalletTransactions = () =>
  createSelector(
    selectSavingWalletDomain, 
    (substate: SavingWalletState) => substate.transactionsData?.data?.history || []
  );

export const savingWalletSelectors = {
  walletData: makeSelectWalletData(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  previousPoints: makeSelectPreviousPoints(),
  milestoneToShow: makeSelectMilestoneToShow(),
  showingMilestone: makeSelectShowingMilestone(),
  totalPoints: makeSelectTotalPoints(),
  hasSavingWallet: makeSelectHasSavingWallet(),
  walletHistory: makeSelectWalletHistory(),
  transactionsData: makeSelectTransactionsData(),
  transactionsLoading: makeSelectTransactionsLoading(),
  transactionsError: makeSelectTransactionsError(),
  walletTransactions: makeSelectWalletTransactions(),
};
